/**
 * Map a Forge agent type to a small emoji, purely as a visual cue in the UI.
 *
 * Exact matches win; otherwise we fall back on suffix/keyword rules so new or
 * niche agent types (e.g. `migration-backend`, `qa-validate`, `*-review`,
 * `*-fix`) still get a sensible glyph instead of the generic robot.
 */
const EXACT_AGENT_EMOJI: Record<string, string> = {
  'epic-planner': '🧭',
  'bootstrap-planner': '🧭',
  planner: '🧭',
  'solution-architect': '🏗️',
  backend: '⚙️',
  web: '🌐',
  mobile: '📱',
  qa: '🧪',
  'qa-validate': '🧪',
  devops: '🚀',
  secops: '🔒',
  'docs-agent': '📝',
  init: '🌱',
  bugfix: '🐞',
  solo: '🦸',
  'merge-conflict-resolver': '🔀',
  'retry-analyst': '🔁',
  'migration-analyst': '📦',
  'migration-backend': '📦',
  'safety-net-analyst': '🛡️',
  'safety-net-qa': '🛡️',
};

export function agentEmoji(agentType: string | null | undefined): string {
  const key = (agentType ?? '').trim().toLowerCase();
  if (!key) return '🤖';
  if (EXACT_AGENT_EMOJI[key]) return EXACT_AGENT_EMOJI[key];
  if (key.endsWith('-review')) return '🔍';
  if (key.endsWith('-fix')) return '🔧';
  if (key.includes('planner') || key.includes('architect')) return '🧭';
  if (key.includes('migration')) return '📦';
  if (key.includes('safety-net')) return '🛡️';
  if (key.includes('qa')) return '🧪';
  if (key.includes('backend')) return '⚙️';
  if (key.includes('mobile')) return '📱';
  if (key.includes('web')) return '🌐';
  if (key.includes('devops')) return '🚀';
  if (key.includes('sec')) return '🔒';
  if (key.includes('doc')) return '📝';
  return '🤖';
}
